export const SHARE_MODES = ['explore', 'guided', 'locked'];
export const SHARE_MODE_INFO = {
    explore: {
        mode: 'explore',
        label: 'share.explore.label',
        description: 'share.explore.description',
        contentBeforePresentation: true,
        freeMovement: true,
    },
    guided: {
        mode: 'guided',
        label: 'share.guided.label',
        description: 'share.guided.description',
        contentBeforePresentation: false,
        freeMovement: true,
    },
    locked: {
        mode: 'locked',
        label: 'share.locked.label',
        description: 'share.locked.description',
        contentBeforePresentation: false,
        freeMovement: false,
    },
};
export const isShareMode = (value) => typeof value === 'string' && SHARE_MODES.includes(value);
//# sourceMappingURL=share.js.map